import { register as registerSubscription } from '@ms/yammer-data/dist/domains/pushSubscriptions/actions';
import { subscribe } from '@ms/yammer-web-support/dist/pushNotifications';
import type { MutableRefObject } from 'react';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useGetPushSubscriptionServerKey } from '../pushSubscriptionServerKey';

export const useCreatePushSubscriptionCallback = (
  subscription: MutableRefObject<PushSubscription | null | undefined>
): (() => Promise<void>) => {
  const dispatch = useDispatch();

  const applicationServerKey = useGetPushSubscriptionServerKey();

  return useCallback(async () => {
    if (subscription.current != null || !applicationServerKey) {
      return;
    }

    const result = await subscribe(applicationServerKey);
    if (!result) {
      return;
    }

    // eslint-disable-next-line react-hooks/immutability
    subscription.current = result;
    await dispatch(registerSubscription(subscription.current, applicationServerKey));
  }, [subscription, dispatch, applicationServerKey]);
};
